/* =================================================================
   SENSE5 - Fluid Layer 2.3
   Scroller, Fortschritt, Reveal-Sicherung, Formulare.
   Laeuft als erstes defer-Script im head, also vor allen Sektions-
   Scripten und vor s5v2-core.js.
   Der Zustand der Kopfzeile liegt in sections/main-global-menu.liquid.
   ================================================================= */
(function () {
  'use strict';
  if (window.S5_FLUID) return;
  window.S5_FLUID = true;

  var doc = document;
  var root = doc.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --------------------------------------------------------------
     1  Welcher Knoten scrollt wirklich?
     Nach dem Fix ist es das Fenster. Auf Browsern ohne overflow:clip
     bleibt es der body - dann muss ScrollTrigger das wissen, sonst
     feuert kein einziger Trigger.
     -------------------------------------------------------------- */
  function detectScroller() {
    var b = doc.body;
    if (b && b.scrollHeight > b.clientHeight + 4) {
      var ov = getComputedStyle(b).overflowY;
      if (ov === 'scroll' || ov === 'auto') return b;
    }
    return window;
  }

  var scroller = window;
  function scrollTop() {
    return scroller === window
      ? (window.pageYOffset || doc.documentElement.scrollTop || 0)
      : scroller.scrollTop;
  }
  function scrollMax() {
    return scroller === window
      ? Math.max(1, doc.documentElement.scrollHeight - window.innerHeight)
      : Math.max(1, scroller.scrollHeight - scroller.clientHeight);
  }
  function bindScroll(fn) {
    (scroller === window ? window : scroller).addEventListener('scroll', fn, { passive: true });
  }

  /* --------------------------------------------------------------
     2  ScrollTrigger auf denselben Scroller setzen
     -------------------------------------------------------------- */
  function wireScrollTrigger() {
    if (!window.ScrollTrigger) return;
    try {
      if (window.gsap && window.gsap.registerPlugin) window.gsap.registerPlugin(window.ScrollTrigger);
      if (scroller !== window) window.ScrollTrigger.defaults({ scroller: scroller });
      window.ScrollTrigger.config({ ignoreMobileResize: true });
    } catch (e) {}
  }

  /* --------------------------------------------------------------
     3  Fortschrittslinie - die Scrollleiste ist ausgeblendet, also
        braucht eine 8000px lange Seite eine andere Ortsangabe.
     -------------------------------------------------------------- */
  var bar = null, ticking = false, header = null;
  function buildProgress() {
    if (doc.getElementById('s5-progress')) return;
    bar = doc.createElement('div');
    bar.id = 's5-progress';
    bar.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(bar);
  }
  function measureHeader() {
    if (!header) header = doc.querySelector('.custom-header-wrapper');
    if (!header) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 20) root.style.setProperty('--s5-header-h', h + 'px');
  }
  function paint() {
    ticking = false;
    if (bar) {
      var p = Math.min(1, Math.max(0, scrollTop() / scrollMax()));
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    sweepSoon();
  }

  /* --------------------------------------------------------------
     4  Reveal-Sicherung
     Auf der Startseite blieben die Tag-Zeilen aller drei Produkt-
     bloecke dauerhaft auf opacity 0, weil das Sicherheitsnetz in
     s5v2-core.js nur eine feste Selektorliste kannte. Hier wird
     jedes sichtbare, aber unsichtbar gebliebene Element eingeblendet.
     -------------------------------------------------------------- */
  var SWEEP = '.s5v2 .idx, .s5v2 .claim, .s5v2 .notes, .s5v2 .tags, .s5v2 .chips,'
            + '.s5v2 .ctas, .s5v2 .unit, .s5v2 .band, .s5v2 .trio, .s5v2 .world,'
            + '.s5v2 .stone-card, .s5v2 .bottle, .s5v2 h1, .s5v2 h2, .s5v2 h3,'
            + '.s5v2 p, .s5v2 li, .s5v2 blockquote, .s5v2 figcaption, .s5v2 .s5v2-btn,'
            + '.s5v2-r';
  var fixed = (typeof WeakSet === 'function') ? new WeakSet() : null;
  var sweepTimer = null;
  var armed = false;

  function reveal(el) {
    if (window.gsap) {
      try { window.gsap.set(el, { clearProps: 'opacity,visibility,transform' }); } catch (e) {}
    }
    var s = getComputedStyle(el);
    if (parseFloat(s.opacity) < 0.05 || s.visibility === 'hidden') {
      el.style.opacity = '1';
      el.style.visibility = 'visible';
      el.style.transform = 'none';
    }
    el.classList.add('is-in');
    if (fixed) fixed.add(el);
  }

  function sweep() {
    if (!armed) return;
    var vh = window.innerHeight;
    var nodes = doc.querySelectorAll(SWEEP);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (fixed && fixed.has(el)) continue;
      if (el.closest && el.closest('.s5v2-hero')) continue;
      var r = el.getBoundingClientRect();
      if (r.height < 6 || r.bottom < 0 || r.top > vh) continue;
      var st = getComputedStyle(el);
      if (parseFloat(st.opacity) < 0.05 && st.display !== 'none') reveal(el);
    }
  }
  function sweepSoon() {
    if (sweepTimer) return;
    sweepTimer = setTimeout(function () { sweepTimer = null; sweep(); }, 900);
  }

  /* --------------------------------------------------------------
     5  will-change nach der Bewegung wieder freigeben
     -------------------------------------------------------------- */
  function releaseLayers() {
    doc.addEventListener('transitionend', function (e) {
      var el = e.target;
      if (el && el.classList && el.classList.contains('s5v2-r') && el.classList.contains('is-in')) {
        el.style.willChange = 'auto';
      }
    }, true);
  }

  /* --------------------------------------------------------------
     6  Aktiver Navigationspunkt
     -------------------------------------------------------------- */
  function markCurrentNav() {
    var h = doc.querySelector('.custom-header-wrapper');
    if (!h) return;
    var here = location.pathname.replace(/\/+$/, '') || '/';
    var links = h.querySelectorAll('nav a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var path;
      try { path = new URL(a.href, location.origin).pathname.replace(/\/+$/, '') || '/'; }
      catch (e) { continue; }
      if (path === '/') continue;
      if (here === path || here.indexOf(path + '/') === 0) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    }
  }

  /* --------------------------------------------------------------
     7  Platzhalter-Cursor
     ts.js (und frueher music.js) schreibt cursor: url(...) auf das
     html-Element. Ist in den Einstellungen kein Bild hinterlegt,
     zeigt der Wert auf Shopifys no-image-Platzhalter.
     -------------------------------------------------------------- */
  function killPlaceholderCursor() {
    function clean() {
      var c = root.style.cursor;
      if (c && c.indexOf('url(') > -1) root.style.cursor = '';
    }
    clean();
    if (window.MutationObserver) {
      new MutationObserver(clean).observe(root, { attributes: true, attributeFilter: ['style'] });
    }
  }

  /* --------------------------------------------------------------
     8  Vorspann: 1,55s Schwarz vor jedem Seitenaufruf sind Latenz,
        kein Design.
     -------------------------------------------------------------- */
  function trimPreloader() {
    var pl = doc.getElementById('s5-preloader');
    if (!pl) return;
    setTimeout(function () { pl.classList.add('s5-pl-done'); }, reduced ? 260 : 600);
  }

  /* --------------------------------------------------------------
     9  Formulare: Status, Fehler, Abschluss sichtbar machen
     -------------------------------------------------------------- */
  var RX = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

  function enhanceForm(form) {
    if (form.__s5) return;
    var input = form.querySelector('input[type="email"]');
    if (!input) return;
    form.__s5 = true;

    if (/^\s*(abonnieren|subscribe|newsletter)\s*$/i.test(input.placeholder || '')) {
      input.placeholder = 'name@beispiel.de';
    }
    input.setAttribute('autocomplete', 'email');
    input.setAttribute('inputmode', 'email');

    var note = form.querySelector('.s5-field__note');
    if (!note) {
      note = doc.createElement('p');
      note.className = 's5-field__note';
      note.setAttribute('aria-live', 'polite');
      form.appendChild(note);
    }

    function validate(silent) {
      var v = (input.value || '').trim();
      if (!v) {
        input.removeAttribute('aria-invalid');
        if (!silent) { note.removeAttribute('data-state'); note.textContent = ''; }
        return false;
      }
      var ok = RX.test(v);
      input.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (ok) { note.removeAttribute('data-state'); note.textContent = ''; }
      else { note.setAttribute('data-state', 'error'); note.textContent = 'Diese Adresse sieht noch nicht vollstaendig aus.'; }
      return ok;
    }

    input.addEventListener('blur', function () { validate(false); });
    input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid') === 'true') validate(true);
    });

    form.addEventListener('submit', function (e) {
      if (!validate(false)) {
        e.preventDefault();
        input.focus();
        return;
      }
      var btn = form.querySelector('button[type="submit"], input[type="submit"], button:not([type])');
      if (btn) {
        btn.classList.add('s5-busy');
        btn.setAttribute('aria-busy', 'true');
      }
      note.removeAttribute('data-state');
      note.textContent = 'Einen Moment ...';
    });
  }

  function enhanceForms() {
    var forms = doc.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('input[type="email"]')) enhanceForm(forms[i]);
    }
  }

  /* --------------------------------------------------------------
     Start
     -------------------------------------------------------------- */
  function boot() {
    scroller = detectScroller();
    wireScrollTrigger();
    buildProgress();
    bindScroll(onScroll);
    window.addEventListener('resize', function () {
      scroller = detectScroller();
      measureHeader();
      paint();
      if (window.ScrollTrigger) { try { window.ScrollTrigger.refresh(); } catch (e) {} }
    }, { passive: true });
    measureHeader();
    paint();
    markCurrentNav();
    killPlaceholderCursor();
    trimPreloader();
    releaseLayers();
    enhanceForms();
    window.S5_SCROLLER = scroller;

    setTimeout(function () { armed = true; sweep(); }, 1500);
    setTimeout(sweep, 3000);
    setTimeout(function () {
      measureHeader();
      if (window.ScrollTrigger) { try { window.ScrollTrigger.refresh(); } catch (e) {} }
    }, 1200);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();

  doc.addEventListener('shopify:section:load', function () {
    header = null;
    enhanceForms();
    markCurrentNav();
    measureHeader();
  });
})();
